import { Field, useFormikContext } from 'formik';
import { useDispatch } from 'react-redux';

import {
  Form,
  trimFormValues,
  InputField,
  normalizeInteger
} from 'common/components/forms';
import { convertStringToInteger } from 'common/helpers/numberHelper';
import { updateCartItem } from 'redux/cart/actions';
import { useLocalization } from 'redux/localization/utils/hooks';

import { validateUpdateCart } from './validators';

const QuantityInput = (props) => {
  const { item, onIsQuantityUpdating } = props;

  const dispatch = useDispatch();
  const { t } = useLocalization();

  const handleSubmit = (values, formik) => {
    const data = transformData(values);
    onIsQuantityUpdating(true);
    const onError = () => {
      formik.setSubmitting(false);
      onIsQuantityUpdating(false);
    };
    const onSuccess = () => {
      formik.setSubmitting(false);
      onIsQuantityUpdating(false);
    };
    let useLoyaltyPoints = false;
    if (item.itemData?.useLoyaltyPoints) {
      useLoyaltyPoints = true;
    }
    dispatch(
      updateCartItem(
        item.id,
        data.quantity,
        useLoyaltyPoints,
        onSuccess,
        onError
      )
    );
  };

  return (
    <Form
      validate={(values) => validate(values, t)}
      initialValues={getInitialValues(item)}
      onSubmit={handleSubmit}
    >
      <div className="c7-order-item__quantity--input">
        <Field
          name="quantity"
          id={`c7-quantity-${item.id}`}
          type="text"
          inputMode="numeric"
          label={t('products.general.quantity')}
          labelSROnly
          component={InputField}
          normalize={normalizeInteger}
          required
        />
        <Button />
      </div>
    </Form>
  );
};

const Button = () => {
  const { t } = useLocalization();
  const formikContext = useFormikContext();

  if (formikContext.isSubmitting) {
    return (
      <button
        type="submit"
        className="c7-btn c7-btn--alt--small c7-btn--loading"
        aria-live="polite"
        disabled
      >
        <span aria-hidden="true">
          {t('general.common.update')}
          <span className="c7-sr-only">{t('products.general.quantity')}</span>
        </span>
        <div className="c7-spinner" role="status" />
      </button>
    );
  }
  return (
    <button className="c7-btn c7-btn--alt--small" type="submit">
      {t('general.common.update')}
      <span className="c7-sr-only">{t('products.general.quantity')}</span>
    </button>
  );
};

const transformData = (formValues) => {
  const values = trimFormValues(formValues);

  const data = {
    quantity: values.quantity && convertStringToInteger(values.quantity)
  };
  return data;
};

const validate = (values, t) => {
  const data = transformData(values);
  const errors = validateUpdateCart(data, t);
  return errors;
};

const getInitialValues = (item) => {
  const { quantity } = item;
  return {
    quantity
  };
};

export default QuantityInput;
